/**
 * Seeded PRNG utility (§2: "Determinism: seeded RNG utility from day 1, used
 * by anything a restart must reproduce"). Nothing in S00 needs randomness
 * yet — this just establishes the one seeded source future sessions must
 * route through for anything a restart/replay has to reproduce (layout,
 * loot, spawn picks). Real (non-reproducible) per-frame juice should keep
 * using Math.random(), per §0.7's carried-over Classic law.
 *
 * mulberry32 — small, fast, good-enough statistical quality for gameplay use.
 */
export class SeededRng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  /** Next float in [0, 1). */
  next(): number {
    this.state |= 0;
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Integer in [min, max]. */
  int(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }
}
